<template>
    <div>
        <div class="product-small" v-if="preview">
            <v-card>
                <v-card-text>
                    <sari-courses :vku="data.vku" :pgs="data.pgs" />
                </v-card-text>
            </v-card>
        </div>
        <div class="product-full" v-if="!preview">
            <v-card>
                <v-card-text>
                    <v-tabs color="primary">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab href="#test-client">Test client</v-tab>
                        <v-tab href="#embed">Integration</v-tab>
                        <!-- <v-tab href="#log">Log</v-tab> -->

                        <v-tab-item value="test-client" class="mt-5">
                            <primalgo-client :id="id" />
                        </v-tab-item>

                        <v-tab-item value="embed" class="mt-5">
                            <primalgo-embed :id="id" />
                        </v-tab-item>

                        <v-tab-item value="log" class="mt-5">
                            <primalgo-log :id="id" />
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";

import PrimalgoEmbed from "./Primalgo.Embed";
import PrimalgoClient from "./Primalgo.Client";
import PrimalgoLog from "./Primalgo.Log";

export default {
    data: () => ({
        loading: false,
    }),
    mixins: [ProductMixin],
    components: { PrimalgoEmbed, PrimalgoClient, PrimalgoLog },
    methods: {}
}
</script>